<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2025-08-20 11:29:16
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2025-08-22 10:59:32
 * @FilePath: /epec-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/supplierListMaintenance/components/batchUploadAttchmentDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <e-dialog
      dialog-title="供应商库添加"
      :center-dialog-visible="batchUploadAttchmentVisible"
      popup-width="800px"
      destroy-close
      modal-append-to-body
      @submitPopupData="handleConfirm"
      @resetPopupData="handleCancel"
    >
      <e-table-list
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="true"
      >
        <template slot="上传附件">
          <div class="upload-wrap">
            <span style="color: #f0250f">*</span>
            <span>上传附件</span>
          </div>
        </template>
        <template #operate="slot">
          <eui-btn
            v-if="
              slot.scope.row.fileName !== undefined &&
              slot.scope.row.fileName !== ''
            "
            type="link"
            @click="handleDelete(slot.scope.$index)"
          >
            {{ slot.scope.row.fileName }}
            <eui-icon icon="eicon-r-l-guanbi"></eui-icon>
          </eui-btn>
          <eui-upload
            v-else
            ref="euiUpload"
            :file-list="[]"
            :action="fileUrl"
            :headers="headers"
            :limit="1"
            text="上传文件"
            :limit-file-size="200"
            @handleSuccess="
              (res) => handleUploadSuccess(res, slot.scope.$index)
            "
          ></eui-upload>
        </template>
      </e-table-list>
    </e-dialog>
  </div>
</template>

<script>
import { epecToken } from '@/modules/projectA/utils/globalData';
import api from '@/modules/projectA/api/user';
import eDialog from '../../../components/common/e-dialog';
import eTableList from '../../../components/common/e-table-list';

export default {
  name: 'BatchUploadAttchmentDialog',
  components: {
    eDialog,
    eTableList,
  },
  props: {
    batchUploadAttchmentVisible: {
      type: Boolean,
      default: false,
    },
    companyList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableLabel: [
        { label: '供应商名称', param: 'subCompanyName' },
        { label: '上传附件', param: 'operate', slot: 'operate', header: true },
      ],
      fileUrl: api.fileUploadForSubSupplier,
      headers: epecToken,
    };
  },
  computed: {
    tableData() {
      return this.companyList.map((item) => ({
        ...item,
      }));
    },
  },
  mounted() {
    console.log(this.tableData);
  },
  methods: {
    handleConfirm() {
      console.log('handleConfirm');
      console.log(this.isAllUpload());
      if (this.isAllUpload()) {
        this.$emit('handleConfirm', this.tableData);
      } else {
        this.$message.warning('请先上传附件');
      }
    },
    handleCancel() {
      console.log('handleCancel');
      this.$emit('handleCancel');
    },
    handleUploadSuccess(res, index) {
      console.log(res, index);
      this.$set(this.tableData[index], 'fileName', res.data.fileName);
      this.$set(this.tableData[index], 'ossUrl', res.data.url);
      console.log(this.tableData);
    },
    handleDelete(index) {
      this.$set(this.tableData[index], 'fileName', '');
      this.$set(this.tableData[index], 'ossUrl', '');
      console.log(this.tableData);
    },
    // 判断是否所有供应商都上传了附件
    isAllUpload() {
      return this.tableData.every(
        (item) => item.fileName !== '' && item.fileName !== undefined
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
